// @flow
import React, { useState } from 'react';
// Styles
import './SortButton.css';
// Components
import {
  SortBy
} from 'react-instantsearch-dom';

const SortButton = () => {
  const indexName = process.env.REACT_APP_TYPESENSE_PRODUCT_INDEX || 'product_sales_production';

  return (
  <div className="sort-button">
    <div className="sort-button-text">  Ordenar por: </div>
    <SortBy
      defaultRefinement={indexName}
      items={[
        { value: indexName, label: 'Relevância' },
        { value: `${indexName}/sort/price:desc`, label: 'Maior Preço' },
        { value: `${indexName}/sort/price:asc`, label: 'Menor Preço' },
      ]}
    />
  </div>
      )
}

export default SortButton;